
import {DELETE_MESSAGE_ERROR} from "../../../reducers/messagesReducer";


export const deleteMessageError = (error) =>{
    return {
        type: DELETE_MESSAGE_ERROR,
        payload: {error}
    }
}